/* INTERNATIONALIZATION */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

/* TRANSLATIONS */
import ptTranslations from "../util/locales/pt.json";
import enTranslations from "../util/locales/en.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
  debug: false,
  fallbackLng: "pt-br",
  interpolation: {
    escapeValue: false,
    format: (value, format, lng) => {
      if (value instanceof Date) {
        if (format === "longDate") {
          return new Intl.DateTimeFormat(lng, { dateStyle: "long" }).format(value);
        }
        if (format === "shortDate") {
          return new Intl.DateTimeFormat(lng, { dateStyle: "short"}).format(value);
        }
        if (format === "dayMonth") {
          return new Intl.DateTimeFormat(lng, {
            day: "2-digit",
            month: "short",
          }).format(value);
        }
        if (format === "dayMonthAndHour") {
          const formatted = new Intl.DateTimeFormat(i18n.language, {
            day: '2-digit',
            month: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: lng === 'en' ? true : false,
          }).format(value);
          return formatted.replace(',', ' -');
        }
        if (format === "dateAndHour") {
          const formatted = new Intl.DateTimeFormat(i18n.language, {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: lng === 'en' ? true : false, // 12-hour format for English, 24-hour for others
          }).format(value);
          return formatted.replace(',', ' -');
        }
        if (format === "hourAndDate") {
          const timeFormatter = new Intl.DateTimeFormat(i18n.language, {
            hour: '2-digit',
            minute: '2-digit',
            hour12:  lng === 'en' ? true : false
          });

          const dateFormatter = new Intl.DateTimeFormat(i18n.language, {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
          });

          const formatted = `${timeFormatter.format(value)} - ${dateFormatter.format(value)}`;
          return formatted;
        }
      }
      return value;
    }
  },
  detection: {
    order: ['localStorage', 'cookie', 'navigator'],
    caches: ['localStorage', 'cookie'],
  },
  resources: {
    pt: { 
      translation: ptTranslations 
    },
    en: { 
      translation: enTranslations 
    },
  },
});

export default i18n;
